import { render, staticRenderFns } from "./BatchSendScoreModal.vue?vue&type=template&id=0e8f3d84"
import script from "./BatchSendScoreModal.vue?vue&type=script&lang=js"
export * from "./BatchSendScoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports